module.exports = __webpack_public_path__ + "img/zh.fe3dd969.png";